import React from 'react'
import logo from '../logo.svg'
import Logo from '../assets/images/image1.png'
import appstore from "../assets/images/app-store.svg"
import playstore from "../assets/images/google-play.svg"
const Footer = ({ onContactClick, onPrivacyClick, onTermsClick }) => {
  const getHeaderHeight = () => {
    const header = document.querySelector('.main-header');
    return header ? header.offsetHeight : 0;
  };

  const scrollToSection = (elementId) => {
    const element = document.querySelector(`#${elementId}`);
    if (element) {
      const headerHeight = getHeaderHeight();
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <>
      <footer className="main-footer">
        {/* Upper Footer Section */}
        <div className="footer-upper">
          <div className="footer-container">
            <div className="footer-left">
              <div className="footer-logo-section">
                <img src={Logo} alt="Logo" className="footer-logo" />
              </div>
              <nav className="footer-nav">
                {/* <a href="#home" className="footer-nav-link">Home</a>
                <a href="#our-apps" className="footer-nav-link">Our Apps</a>
                <a href="#about" className="footer-nav-link">About</a>
                <a href="#faq" className="footer-nav-link">FAQ</a> */}

                <a
                  href="#home"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }, 100);
                  }}
                >
                  Home
                </a>

                <a
                  href="#our-apps"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("our-apps");
                    }, 100);
                  }}
                >
                  Featured Apps
                </a>


                <a
                  href="#about"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("about");
                    }, 100);
                  }}
                >
                  About
                </a>

                <a
                  href="#faq"
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.hash = "#home";
                    setTimeout(() => {
                      scrollToSection("faq");
                    }, 100);
                  }}
                >
                  FAQ
                </a>
                <a 
                  href="#contact" 
                  className="footer-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (onContactClick) {
                      onContactClick();
                    }
                  }}
                >
                  Contact Us
                </a>
              </nav>
            </div>
            <div className="footer-right">
              <div className="footer-app-download">
                <a
                  href="https://apps.apple.com/sb/developer/di-labs/id1221305504"
                  rel="noopener noreferrer"
                >
                  <img src={appstore} alt="App Store" className="img-fluid" width="190" height="60" />
                </a>
                <a 
                  href="https://play.google.com/store/apps/dev?id=6717661217853138886" 
                  rel="noopener noreferrer"
                >
                  <img src={playstore} alt="Google Play" className="img-fluid" width="190" height="60" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar Section */}
        <div className="footer-bottom">
          <div className="footer-container">
            <div className="footer-bottom-left">
              <p className="footer-copyright">Copyright © 2024. All rights reserved.</p>
            </div>
            <div className="footer-bottom-right">
              <a 
                href="#terms" 
                className="footer-bottom-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (onTermsClick) {
                    onTermsClick();
                  }
                }}
              >
                Terms & condition
              </a>
              <span className="footer-separator">|</span>
              <a 
                href="#privacy" 
                className="footer-bottom-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (onPrivacyClick) {
                    onPrivacyClick();
                  }
                }}
              >
                Privacy policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
